import { scope } from '@/shared/config'
import { enableScopeInspector } from '@/shared/lib/effector-utils'
import { allSettled } from 'effector'
import { createRoot } from 'react-dom/client'

import { App, appStarted } from './app'

if (import.meta.env.DEV) {
  enableScopeInspector()
}
await allSettled(appStarted, { scope })
const root = createRoot(document.getElementById('root') as HTMLElement)
root.render(<App scope={scope} />)
